export default __webpack_public_path__ + "static/assets/aptechko_icon.0cf67fcc.png";